import { createApiRef } from '@backstage/core-plugin-api';
import { McpChatApi } from './McpChatApi';

/**
 * @public
 */
export const mcpChatApiRef = createApiRef<McpChatApi>({
  id: 'plugin.mcp-chat.service',
});
